<template>
    <div class="section session-header px-6 mx-6 pb-4">
        <nav class="level mb-0">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-4">
                        <span class="primary-font has-text-black is-uppercase">{{$t('session_stats')}}</span>: <span class="primary-font has-text-eduloc-red">{{ title }}</span>
                    </p>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <p class="is-size-4 has-text-eduloc-blue primary-font">{{gameType}}</p>
                </div>
            </div>
        </nav>
        <div class="">
            <p class="">
                <span class="has-text-black secondary-font-bold">{{$t('start_date')}}:</span>&nbsp;
                <span v-if="isArchived" class="has-text-eduloc-red secondary-font-bold">{{ configuration.startDate | timeFormatPost }}</span>
                <span v-else class="has-text-eduloc-red secondary-font-bold">{{ created | timeFormatPost }}</span>
                &nbsp;<span class="has-text-black secondary-font-bold">|</span>&nbsp;
                <span class="has-text-black secondary-font-bold">{{$t('end_date')}}:</span>&nbsp;
                <span class="has-text-eduloc-red secondary-font-bold">{{ configuration.limitDate | timeFormatPost }}</span>
            </p>
        </div>
    </div>
     <!--<div>
       <section :style="`${background};`" class="hero">
            <div class="hero-body has-text-white is-relative">
                <div
                    class="is-overlay has-background-link lb-hero-background"
                ></div>
                <div class="container has-text-centered">
                    <div class="columns is-centered">
                        <div class="column is-narrow">
                            <figure class="image is-148x148 ml-3">
                                <vue-qrcode
                                    ref="qrcode"
                                    :value="shareSessionURL"
                                />
                            </figure>
                        </div>
                        <div
                            class="
                                column
                                is-narrow
                                has-text-left has-text-centered-mobile
                            "
                        >
                            <p
                                class="
                                    title
                                    has-text-weight-bold
                                    is-size-5
                                    has-text-white
                                "
                            >
                                {{ title }}
                            </p>
                            <p>
                                <strong
                                    v-t="'Sessions.type'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ projectType }}
                            </p>
                            <p>
                                <strong
                                    v-t="'Sessions.owner'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ owner.username }}
                            </p>
                            <p v-if="configuration.startDate">
                                <strong
                                    v-t="'Sessions.game_start'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ configuration.startDate | timeFormat }}
                            </p>
                            <p v-if="configuration.limitDate">
                                <strong
                                    v-t="'Sessions.game_end'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ configuration.limitDate | timeFormat }}
                            </p>
                            <p>
                                <strong
                                    v-t="'Sessions.shortcode'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ shortCode }}
                            </p>
                        </div>
                    </div>
                    <div class="columns is-centered">
                        <div class="column is-half">
                            <app-copiable-field :text="shareSessionURL" />
                        </div>
                    </div>
                    <div class="columns is-centered">
                        <div class="column is-half">
                            <a
                                :href="shareSessionURL"
                                target="_blank"
                                class="button is-primary"
                                >{{ $t('Sessions.go_to_play') }}</a
                            >
                        </div>
                    </div>
                    <div class="columns is-centered">
                        <div class="column is-half">
                            <div
                                class="
                                    columns
                                    is-centered
                                    pt-6
                                    is-mobile is-multiline
                                "
                            >
                                <div
                                    v-if="project.type == 'treasurehunt'"
                                    class="column px-6-tablet"
                                >
                                    <div>
                                        <div
                                            class="
                                                lb-circle
                                                is-small
                                                has-background-primary
                                            "
                                        >
                                            <p class="has-text-weight-bold">
                                                {{ cluesCount }}
                                            </p>
                                        </div>
                                        <p
                                            v-t="'Sessions.clue_count'"
                                            class="has-text-weight-bold"
                                        ></p>
                                    </div>
                                </div>
                                <div class="column px-6-tablet">
                                    <div>
                                        <div
                                            class="
                                                lb-circle
                                                is-small
                                                has-background-primary
                                            "
                                        >
                                            <p class="has-text-weight-bold">
                                                {{ questionsCount }}
                                            </p>
                                        </div>
                                        <p
                                            v-t="'Sessions.questions'"
                                            class="has-text-weight-bold"
                                        ></p>
                                    </div>
                                </div>
                                <div class="column px-6-tablet">
                                    <div>
                                        <div
                                            class="
                                                lb-circle
                                                is-small
                                                has-background-primary
                                            "
                                        >
                                            <p class="has-text-weight-bold">
                                                {{ activeParticipants.length }}
                                            </p>
                                        </div>
                                        <p
                                            v-t="'Sessions.participants_count'"
                                            class="has-text-weight-bold"
                                        ></p>
                                    </div>
                                </div>
                                <div class="column px-6-tablet">
                                    <div>
                                        <div
                                            class="
                                                lb-circle
                                                is-small
                                                has-background-primary
                                            "
                                        >
                                            <p class="has-text-weight-bold">
                                                {{ hitRate }}
                                            </p>
                                        </div>
                                        <p
                                            v-t="'Sessions.hit_rate'"
                                            class="has-text-weight-bold"
                                        ></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>-->
</template>

<script>

import _ from 'underscore';
import moment from 'moment';
export default {
    components: {
    },
    filters: {
        timeFormat(timestamp) {
            return moment(timestamp).format('DD/MM/YY HH:mm');
        },
        timeFormatPost(timestamp) {
            return moment(timestamp).format('DD/MM/YY');
        },
    },
    props: {
        title: {
            type: String,
            default: undefined,
        },
        scores: {
            type: Array,
            default: () => {
                return [];
            },
        },
        shortCode: {
            type: String,
            default: '',
        },
        configuration: {
            type: Object,
            default() {
                return {};
            },
        },
        project: {
            type: Object,
            default() {
                return {};
            },
        },
        participants: {
            type: Array,
            default() {
                return [];
            },
        },
        context: {
            type: Array,
            default() {
                return [];
            },
        },
        owner: {
            type: Object,
            default() {
                return {};
            },
        },
        isActive: {
            type: Boolean,
            default: false
        }
        ,
        isPaused: {
            type: Boolean,
            default: false
        },
        isArchived: {
            type: Boolean,
            default: false
        },
        created: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {};
    },
    computed: {
        gameType(){
            if(this.project && this.project.format){
                return this.$t(`Constants.${this.project.format}`);
            }else if(this.project && this.project.mode=='map'){
                return this.$t('Constants.PROJECT_TYPE_GEOQUIZ');
            }
            return this.$t('Constants.PROJECT_TYPE_QUIZ');
        },
        
        /*hitRate() {
            if (this.scores.length === 0) {
                return 0;
            }
            const answeredRight = _.filter(this.scores, (score) => {
                return score.points > 0;
            });
            return ((answeredRight.length / this.scores.length) * 100).toFixed(
                0
            );
        },
        projectType() {
            if (
                this.project.type === 'trivial' &&
                this.project.mode === 'map'
            ) {
                return this.$t('Creation.trivialgeo.title');
            } else if (
                this.project.type === 'trivial' &&
                this.project.mode === 'map'
            ) {
                return this.$t('Creation.trivial.title');
            } else {
                return this.$t(`App.${this.project.type}`);
            }
        },
        questionsCount() {
            const totalQuestions = _.filter(this.context, (question) => {
                return question.type == 'question' || question.answers;
            });
            return totalQuestions.length;
        },
        cluesCount() {
            const totalClues = _.filter(this.context, (element) => {
                return element.triggers && element.triggers.GO_TO_POINT;
            });
            return totalClues.length;
        },
        activeParticipants() {
            let players = _.groupBy(this.scores, (score) => {
                return score.owner.owner;
            });
            return _.map(players, (scores, player) => {
                return {
                    name: scores[0].owner.name,
                    owner: scores[0].owner.owner,
                    score: _.reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.points;
                        },
                        0
                    ),
                    time: _.reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.time;
                        },
                        0
                    ),
                };
            });
        },*/
    },
    mounted() {
        // console.log(this.participants)
        // console.log(this.isActive,this.isPaused,this.isArchived)
    },
};
</script>

<style scoped>
</style>
